"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootGuidesSagas = void 0;
var effects_1 = require("redux-saga/effects");
var actions_1 = require("@/pages/guides/actions/actions");
var EnqueueTokenSaga_1 = require("@/pages/common/sagas/EnqueueTokenSaga");
var GuidesApiToken_1 = require("@/api/remote/protected/GuidesApiToken");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var watchOnPageChange = function () {
    var _loop_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_1 = function () {
                    var action, state, language, languageCode, data, result, newUrl, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(actions_1.default.CHANGE_PAGE)];
                            case 1:
                                action = _a.sent();
                                return [4 /*yield*/, effects_1.select()];
                            case 2:
                                state = _a.sent();
                                _a.label = 3;
                            case 3:
                                _a.trys.push([3, 7, , 9]);
                                language = state.layout.language.languages
                                    .filter(function (it) { return it.id === state.layout.language.current; })[0];
                                languageCode = language.code1;
                                data = {
                                    pageNumber: action.payload,
                                    searchByTag: 0,
                                    searchText: state.guides.currentSearchSet.searchText,
                                    altSearchText: state.guides.currentSearchSet.altSearchText,
                                };
                                if (state.searchSection.searchText.length > 0) {
                                    data = __assign(__assign({}, data), { searchByTag: 1, searchText: state.searchSection.searchText, altSearchText: state.searchSection.searchText });
                                }
                                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, GuidesApiToken_1.getGuidesApiToken, data, languageCode)];
                            case 4:
                                result = _a.sent();
                                newUrl = window.location.pathname + "?pno=" + action.payload;
                                window.history.replaceState(null, null, newUrl);
                                return [4 /*yield*/, effects_1.put(actions_1.default.reloadItems(result.data.guides))];
                            case 5:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(actions_1.default.reloadPager(result.data.pager))];
                            case 6:
                                _a.sent();
                                window.location.hash = 'guides';
                                return [3 /*break*/, 9];
                            case 7:
                                e_1 = _a.sent();
                                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiSearchError:pagechange'))];
                            case 8:
                                _a.sent();
                                console.log(e_1);
                                return [3 /*break*/, 9];
                            case 9: return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnSearchTextChange = function () {
    var _loop_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_2 = function () {
                    var action, state_1, language, languageCode, result, e_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(actions_1.default.SET_SEARCH_TEXT)];
                            case 1:
                                action = _a.sent();
                                _a.label = 2;
                            case 2:
                                _a.trys.push([2, 8, , 10]);
                                return [4 /*yield*/, effects_1.put(actions_1.default.setSearchKeywords([]))];
                            case 3:
                                _a.sent();
                                return [4 /*yield*/, effects_1.select()];
                            case 4:
                                state_1 = _a.sent();
                                if (!(action.payload.length > 2)) return [3 /*break*/, 7];
                                language = state_1.layout.language.languages
                                    .filter(function (it) { return it.id === state_1.layout.language.current; })[0];
                                languageCode = language.code1;
                                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, GuidesApiToken_1.getGuidesKeywordsApiToken, {
                                        searchText: state_1.searchSection.searchText,
                                    }, languageCode)];
                            case 5:
                                result = _a.sent();
                                return [4 /*yield*/, effects_1.put(actions_1.default.setSearchKeywords(result.data.keywords))];
                            case 6:
                                _a.sent();
                                _a.label = 7;
                            case 7: return [3 /*break*/, 10];
                            case 8:
                                e_2 = _a.sent();
                                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiSearchError:searchtext'))];
                            case 9:
                                _a.sent();
                                console.log(e_2);
                                return [3 /*break*/, 10];
                            case 10: return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_2()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSearchButtonClick = function () {
    var _loop_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_3 = function () {
                    var state, language, languageCode, result, newUrl, e_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(actions_1.default.SEARCH_GUIDES)];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, effects_1.select()];
                            case 2:
                                state = _a.sent();
                                _a.label = 3;
                            case 3:
                                _a.trys.push([3, 13, , 15]);
                                language = state.layout.language.languages
                                    .filter(function (it) { return it.id === state.layout.language.current; })[0];
                                languageCode = language.code1;
                                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, GuidesApiToken_1.getGuidesApiToken, {
                                        pageNumber: 1,
                                        searchByTag: 1,
                                        searchText: state.searchSection.searchText,
                                        altSearchText: state.searchSection.searchText,
                                    }, languageCode)];
                            case 4:
                                result = _a.sent();
                                newUrl = "/" + languageCode + "/property-guides";
                                window.history.replaceState(null, null, newUrl);
                                if (!(result.data.guides && Array.isArray(result.data.guides))) return [3 /*break*/, 6];
                                return [4 /*yield*/, effects_1.put(actions_1.default.reloadItems(result.data.guides))];
                            case 5:
                                _a.sent();
                                return [3 /*break*/, 8];
                            case 6: return [4 /*yield*/, effects_1.put(actions_1.default.reloadItems([]))];
                            case 7:
                                _a.sent();
                                _a.label = 8;
                            case 8: return [4 /*yield*/, effects_1.put(actions_1.default.reloadPager(result.data.pager))];
                            case 9:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(actions_1.default.resetHeader(state.searchSection.searchText))];
                            case 10:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(actions_1.default.resetMenu())];
                            case 11:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(actions_1.default.resetDistricts())];
                            case 12:
                                _a.sent();
                                return [3 /*break*/, 15];
                            case 13:
                                e_3 = _a.sent();
                                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiSearchError:search'))];
                            case 14:
                                _a.sent();
                                console.log(e_3);
                                return [3 /*break*/, 15];
                            case 15: return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_3()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var rootGuidesSagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    watchOnPageChange: watchOnPageChange,
    watchOnSearchTextChange: watchOnSearchTextChange,
    watchSearchButtonClick: watchSearchButtonClick,
};
exports.rootGuidesSagas = rootGuidesSagas;
